import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.723 7.335L12.42 14.25H5.58L3.277 7.335 9 3.33l5.723 4.005zM1.5 6.75l3 9h9l3-9L9 1.5 1.5 6.75z" fill="#54585D" /></svg>);